import React from "react";
import { useParams } from "react-router-dom";
import { getGameConfig } from "../games";
import { useGameplaySession } from "../hooks/useGameplaySession";
import { GameStatus } from "../types/gameplay";
import { getScalinataMaxGuesses, getScalinataWordLengths } from "../gameVariants";
import ScalinataGame from "./ScalinataGame";

const Scalinata = () => {
  const { date } = useParams();
  const gameConfig = getGameConfig("scalinata");

  const {
    puzzleConfig,
    state: sessionState,
    solutions,
    status,
    gameOver,
    won,
    justLost,
    justWon,
    isLoading,
    error: sessionError,
    isEventPending,
    dispatchEvent,
    dispatchHintEvent,
    hintAllowance,
    refreshHintAllowance,
    isSignedIn,
  } = useGameplaySession(gameConfig.id, date, {
    deriveStatusFromLocalStorage: (data) => {
      if (!data) return GameStatus.NOT_STARTED;
      const guesses = data.guesses || {};
      const usedGuesses = Object.values(guesses).reduce((sum, arr) => sum + arr.length, 0);
      const wordLengths = getScalinataWordLengths(data);
      const maxGuesses = getScalinataMaxGuesses(data);
      const lastLevelIndex = Math.max(0, wordLengths.length - 1);
      const lastRoundGuesses = guesses[lastLevelIndex] || [];
      const won = lastRoundGuesses[lastRoundGuesses.length - 1]?.feedback?.every(f => f.state === 'correct') || false;
      if (won) return GameStatus.WON;
      if (usedGuesses >= maxGuesses) return GameStatus.LOST;
      if (usedGuesses > 0) return GameStatus.IN_PROGRESS;
      return GameStatus.NOT_STARTED;
    },
  });

  return (
    <ScalinataGame
      key={sessionState?.session_id || date}
      date={date}
      gameConfig={gameConfig}
      puzzleConfig={puzzleConfig}
      sessionState={sessionState}
      solutions={solutions}
      status={status}
      gameOver={gameOver}
      won={won}
      justLost={justLost}
      justWon={justWon}
      isLoading={isLoading}
      sessionError={sessionError}
      isEventPending={isEventPending}
      dispatchEvent={dispatchEvent}
      dispatchHintEvent={dispatchHintEvent}
      hintAllowance={hintAllowance}
      refreshHintAllowance={refreshHintAllowance}
      isSignedIn={isSignedIn}
    />
  );
};

export default Scalinata;
